import {
  Component, ElementRef, OnInit
} from '@angular/core';
import { Observable, of } from 'rxjs';
import { IObjectDTO, SessionDTO, TaskDTO } from '../api/plyca-dtos';
import { ObjectContextDTO } from '../api/plyca-dtos-v2';
import { FormConfig } from '../components/forms/form.objects';

import { BaseFormComponent, BaseFormHeaderInfo } from '../tasks/baseFormComponent/baseForm.component';


export class DemoObjetDTO implements IObjectDTO<string> {
  identifier: string;
  task: TaskDTO;
  context?: ObjectContextDTO;
  price: number;
  finalPrice: number;
  discount: number;
}

@Component({
  selector: 'demo1',
  templateUrl: '../tasks/baseFormComponent/baseForm.template.html'
})
// tslint:disable-next-line:class-name
export class demo1Component extends BaseFormComponent<DemoObjetDTO, DemoObjetDTO> implements OnInit {

  public model: DemoObjetDTO;

  getDataObservable(): DemoObjetDTO {
    let model = new DemoObjetDTO();
    model.price = 1000;
    model.discount = 10;
    this.updateFinalPrice(model);
    return model;
  }

  getFormSettingURL(): string {
    return 'demo.json';
  }
  getServiceURL(operation?: string): string {
    return undefined;
  }
  getObjectIdentifier() {
    return undefined;
  }
  dtoToModel(dto: DemoObjetDTO): Observable<DemoObjetDTO> {
    return of(dto);
  }
  modelToDTO(model: any): DemoObjetDTO {
    return model;
  }
  getHeaderInfo(): BaseFormHeaderInfo {
    return undefined;
  }
  initHeaderActions() {
  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.showValidations = true;
    formConfig.functions.push({
      identifier: 'calculateFinalPrice',
      fn: this.calculateFinalPrice.bind(this)
    });
    formConfig.functions.push({
      identifier: 'calculateDiscount',
      fn: this.calculateDiscount.bind(this)
    });
    formConfig.functions.push({
      identifier: 'setFinalPrice',
      fn: this.setFinalPrice.bind(this)
    });
    formConfig.functions.push({
      identifier: 'setDiscount',
      fn: this.setDiscount.bind(this)
    });
    return of(formConfig);
  }

  public calculateFinalPrice(): number {
    console.log('calculatePrice');
    return (this.model.discount) ? this.model.price * (100 - this.model.discount) / 100 : this.model.finalPrice;
  }

  public setFinalPrice(): void {
    console.log('setFinalPrice');
    this.updateFinalPrice(this.model);
  }

  private updateFinalPrice(object: DemoObjetDTO): void {
    object.finalPrice = object.price * (100 - object.discount) / 100;
  }

  public calculateDiscount(): number {
    console.log('calculateDiscount');
    return (this.model.finalPrice) ? 100 - (this.model.finalPrice * 100 / this.model.price) : this.model.discount;
  }


  public setDiscount(): void {
    console.log('setDiscount');
    this.model.discount = 100 - (this.model.finalPrice * 100 / this.model.price);
  }

}
